import { render, staticRenderFns } from "./SalesOrderPushAlert.vue?vue&type=template&id=1bb36492&scoped=true&"
import script from "./SalesOrderPushAlert.vue?vue&type=script&lang=js&"
export * from "./SalesOrderPushAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb36492",
  null
  
)

export default component.exports